<!-- Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved. -->

<template>
  <router-view></router-view>
</template>

<script lang="ts">
export default {
    name: 'auth-view',
};
</script>
